var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/init-masonry-registry.ts
import { MasonryDriverNodeRenderersRegistry } from "@leagueplatform/masonry";
import {
  MasonryAccordionItemRenderer,
  NODE_TYPE_ACCORDION_ITEM
} from "@leagueplatform/masonry-renderers";

// src/components/masonry-renderers/border-box/border-box-renderer.component.tsx
import * as React from "react";
import { Box } from "@leagueplatform/genesis-core";
var NODE_TYPE_BORDER_BOX = "borderBox";
function BorderBoxRenderer({ items }) {
  if (!items || !items.length)
    return null;
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      css: {
        paddingBlock: "$two",
        paddingInline: "$oneAndHalf",
        borderRadius: "$card",
        borderColor: "$onSurfaceBorderSubdued",
        borderStyle: "solid",
        borderWidth: "$card"
      }
    },
    items
  );
}

// src/constants/masonry.constants.ts
var BENEFITS_ROOT_NODE_IDS = {
  benefitsLandingRootNodeId: "core$benefits$landingPage$root",
  benefitsDetailRootNodeId: "core$benefits$detailPage$root"
};
var MASONRY_NAMESPACE_BENEFITS = "benefits";

// src/components/masonry-renderers/section-header/section-header-renderer.component.tsx
import * as React2 from "react";
import {
  MasonrySectionHeaderRenderer
} from "@leagueplatform/masonry-renderers";
var NODE_TYPE_SECTION_HEADER = "sectionHeader";
var SectionHeaderRenderer = (props) => /* @__PURE__ */ React2.createElement(MasonrySectionHeaderRenderer, __spreadProps(__spreadValues({}, props), { paddingTop: "$none" }));

// src/components/masonry-renderers/grid-layout/grid-layout.component.tsx
import * as React3 from "react";
import {
  MasonryGridLayoutRenderer
} from "@leagueplatform/masonry-renderers";
var NODE_TYPE_GRID_LAYOUT = "gridLayout";
var GridLayoutRenderer = (props) => /* @__PURE__ */ React3.createElement(MasonryGridLayoutRenderer, __spreadValues({}, props));

// src/components/masonry-renderers/sidebar-layout/sidebar-layout.component.tsx
import * as React4 from "react";
import {
  MasonrySidebarLayoutRenderer
} from "@leagueplatform/masonry-renderers";
var NODE_TYPE_SIDEBAR_LAYOUT = "sidebarLayout";
var SidebarLayoutRenderer = (props) => /* @__PURE__ */ React4.createElement(MasonrySidebarLayoutRenderer, __spreadValues({}, props));

// src/components/masonry-renderers/member-dropdown-container/member-dropdown-container.component.tsx
import * as React5 from "react";
import {
  Box as Box2,
  colorTokenMap
} from "@leagueplatform/genesis-core";
import { MaxWidthWrapper } from "@leagueplatform/web-common-components";
var NODE_TYPE_MEMBER_DROPDOWN_CONTAINER = "memberDropdownContainer";
function MemberDropdownContainer({
  items,
  backgroundColor: colorToken = "surfaceCardPrimary"
}) {
  var _a;
  if (!items || !items.length)
    return null;
  const backgroundColor = (_a = colorTokenMap[colorToken]) != null ? _a : colorToken;
  return /* @__PURE__ */ React5.createElement(
    Box2,
    {
      css: {
        backgroundColor,
        padding: "$three",
        "@mobile": {
          padding: "$two $oneAndHalf"
        }
      }
    },
    /* @__PURE__ */ React5.createElement(
      MaxWidthWrapper,
      {
        css: {
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          "@mobile": {
            gridTemplateColumns: "1fr"
          }
        }
      },
      items
    )
  );
}

// src/components/masonry-renderers/member-dropdown/member-dropdown-renderer.component.tsx
import * as React6 from "react";
import { useInvokeAction } from "@leagueplatform/masonry";
import { FormField, Select } from "@leagueplatform/genesis-core";
var NODE_TYPE_MEMBER_DROPDOWN = "memberDropdown";
function MemberDropdownRenderer({
  label,
  options,
  value: defaultValue,
  onSelect
}) {
  const invokeAction = useInvokeAction();
  const [value, setValue] = React6.useState(defaultValue);
  const handleChange = React6.useCallback(
    (event) => {
      setValue(event.target.value);
      if (onSelect) {
        invokeAction(__spreadProps(__spreadValues({
          event
        }, onSelect), {
          payload: __spreadProps(__spreadValues({}, onSelect.payload), {
            queryParams: __spreadProps(__spreadValues({}, onSelect.payload && "queryParams" in onSelect.payload ? onSelect.payload.queryParams : {}), {
              userId: event.target.value
            })
          })
        }));
      }
    },
    [invokeAction, onSelect]
  );
  const id = React6.useMemo(
    () => `member-dropdown-${label.toLowerCase().replace(/\s+/g, "-")}`,
    [label]
  );
  return /* @__PURE__ */ React6.createElement(FormField, { label, id }, /* @__PURE__ */ React6.createElement(Select, { id, options, value, onChange: handleChange }));
}

// src/components/masonry-renderers/id-card/id-card-renderer.component.tsx
import * as React8 from "react";

// src/components/id-card/id-card.component.tsx
import { Box as Box3, Image } from "@leagueplatform/genesis-core";
import * as React7 from "react";
var ASPECT_RATIO_REGEX = /^\d+\s*\/\s*\d+$/;
var formatHandleAspectRatio = (aspectRatio) => {
  if (ASPECT_RATIO_REGEX.test(aspectRatio != null ? aspectRatio : "")) {
    return aspectRatio;
  }
  return aspectRatio == null ? void 0 : aspectRatio.replace(":", "/");
};
var handleBase64Source = (source, type) => {
  if (type === "base64" && !source.startsWith("data:image/png;base64,")) {
    return `data:image/png;base64,${source}`;
  }
  return source;
};
function IdCard({
  source: imageSource,
  description,
  aspectRatio: aspectRatioString,
  type
}) {
  let source = imageSource;
  const aspectRatio = React7.useMemo(
    () => formatHandleAspectRatio(aspectRatioString),
    [aspectRatioString]
  );
  if (type === "base64") {
    const base64Source = handleBase64Source(source, type);
    source = base64Source;
  }
  return /* @__PURE__ */ React7.createElement(Box3, { className: "id-card", css: { display: "inline-flex" } }, /* @__PURE__ */ React7.createElement(
    Image,
    {
      src: source,
      alt: description,
      css: { aspectRatio, maxWidth: "100%", display: "block" }
    }
  ));
}

// src/components/masonry-renderers/id-card/id-card-renderer.component.tsx
var NODE_TYPE_ID_CARD = "idCard";
function IdCardRenderer({
  source,
  description,
  aspectRatio,
  type
}) {
  return /* @__PURE__ */ React8.createElement(
    IdCard,
    {
      aspectRatio,
      description,
      source,
      type
    }
  );
}

// src/components/masonry-renderers/benefits-section-header/benefits-section-header-renderer.component.tsx
import * as React9 from "react";
import {
  Box as Box4,
  HeadingText,
  Image as Image2
} from "@leagueplatform/genesis-core";
var NODE_TYPE_BENEFITS_SECTION_HEADER = "benefitSectionHeader";
function BenefitsSectionHeaderRenderer({
  heading,
  headingLevel = "2",
  icon
}) {
  const { url, description = "" } = icon || {};
  return /* @__PURE__ */ React9.createElement(
    Box4,
    {
      css: {
        display: "flex",
        alignItems: "flex-start",
        gap: "$threeQuarters"
      }
    },
    url && /* @__PURE__ */ React9.createElement(Box4, null, /* @__PURE__ */ React9.createElement(Image2, { css: { width: 42 }, src: url, alt: description })),
    /* @__PURE__ */ React9.createElement(Box4, { css: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ React9.createElement(HeadingText, { size: "lg", level: headingLevel }, heading))
  );
}

// src/components/masonry-renderers/plan-spending-container/plan-spending-container.component.tsx
import * as React10 from "react";
import {
  Box as Box5,
  colorTokenMap as colorTokenMap2
} from "@leagueplatform/genesis-core";

// src/utils/radius-token-map.ts
var radiusTokenMap = {
  none: "$none",
  thin: "$thin",
  thick: "$thick",
  small: "$small",
  medium: "$medium",
  large: "$large",
  extraLarge: "$extraLarge",
  huge: "$huge",
  circle: "$circle",
  pill: "$pill",
  button: "$button",
  inputField: "$inputField",
  card: "$card"
};

// src/components/masonry-renderers/plan-spending-container/plan-spending-container.component.tsx
var NODE_TYPE_PLAN_SPENDING_CONTAINER = "planSpendingContainer";
function PlanSpendingContainerRenderer({
  backgroundColor: colorToken = "surfaceBackgroundSecondary",
  borderRadius: radius = "card",
  items
}) {
  var _a, _b;
  if (!items || !items.length)
    return null;
  const backgroundColor = (_a = colorTokenMap2[colorToken]) != null ? _a : colorToken;
  const borderRadius = (_b = radiusTokenMap[radius]) != null ? _b : radius;
  return /* @__PURE__ */ React10.createElement(
    Box5,
    {
      css: {
        backgroundColor,
        borderRadius,
        padding: "$two"
      }
    },
    items
  );
}

// src/components/masonry-renderers/spending-account-card/spending-account-card-renderer.component.tsx
import * as React12 from "react";
import { useInvokeAction as useInvokeAction2 } from "@leagueplatform/masonry";
import {
  isLinkAction
} from "@leagueplatform/masonry-renderers";

// src/components/spending-account-card/spending-account-card.component.tsx
import * as React11 from "react";
import {
  Box as Box6,
  Card,
  HeadingText as HeadingText2,
  TextAction,
  useClickableCard,
  Icon,
  StackLayout,
  VisuallyHidden,
  focusOutlineOuter
} from "@leagueplatform/genesis-core";
import { useUniqueId } from "@leagueplatform/web-common";
import { InternalOrExternalLink as Link } from "@leagueplatform/web-common-components";
var CARD_MAX_WIDTH = "369px";
function SpendingAccountCard({
  amount,
  ctaText,
  icon,
  trailingIcon,
  title,
  onClick: handleOnClick,
  href = "",
  isLink,
  accountName
}) {
  const { onCardMouseDown, onCardMouseUp, clickAreaRef, primaryActionRef } = useClickableCard();
  const uniqueId = useUniqueId({
    prefix: "spending-account-card"
  });
  if (!amount && !ctaText && !title) {
    return null;
  }
  const trailingIconId = (trailingIcon == null ? void 0 : trailingIcon.description) && `${uniqueId}-trailing-icon`;
  const hasAmountOnly = !ctaText && amount;
  return /* @__PURE__ */ React11.createElement(
    Card.Elevated,
    {
      backgroundColor: "secondary",
      css: {
        maxWidth: CARD_MAX_WIDTH,
        width: "100%",
        "&:focus-within": __spreadValues({}, focusOutlineOuter)
      }
    },
    /* @__PURE__ */ React11.createElement(
      Card.ClickArea,
      {
        onCardMouseDown,
        onCardMouseUp,
        ref: clickAreaRef
      },
      /* @__PURE__ */ React11.createElement(
        Card.Section,
        {
          css: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }
        },
        /* @__PURE__ */ React11.createElement(StackLayout, { spacing: "$half" }, (icon == null ? void 0 : icon.icon) && /* @__PURE__ */ React11.createElement(Icon, { icon: icon.icon, label: icon.description }), title && /* @__PURE__ */ React11.createElement(HeadingText2, { size: "xs", level: "display", as: "p" }, title, amount && /* @__PURE__ */ React11.createElement(HeadingText2, { size: "xl", level: "display" }, amount)), hasAmountOnly && /* @__PURE__ */ React11.createElement(HeadingText2, { size: "xl", level: "display", as: "p" }, amount), ctaText && /* @__PURE__ */ React11.createElement(
          TextAction,
          __spreadProps(__spreadValues({
            "aria-describedby": trailingIconId,
            as: "button",
            ref: primaryActionRef,
            onClick: handleOnClick
          }, isLink && {
            as: Link,
            href
          }), {
            css: {
              '&[class*="GDS"]:focus, &[class*="GDS"]:focus': {
                outline: "none"
              }
            }
          }),
          ctaText,
          accountName && /* @__PURE__ */ React11.createElement(VisuallyHidden, null, " ", accountName)
        )),
        (trailingIcon == null ? void 0 : trailingIcon.icon) && /* @__PURE__ */ React11.createElement(Box6, null, /* @__PURE__ */ React11.createElement(
          Icon,
          {
            id: trailingIconId,
            icon: trailingIcon.icon,
            label: trailingIcon == null ? void 0 : trailingIcon.description
          }
        ))
      )
    )
  );
}

// src/components/masonry-renderers/spending-account-card/spending-account-card-renderer.component.tsx
var NODE_TYPE_SPENDING_ACCOUNT_CARD = "spendingAccountCard";
function SpendingAccountCardRenderer({
  amount,
  ctaText,
  icon,
  trailingIcon,
  title,
  onClick,
  accountName
}) {
  const invokeAction = useInvokeAction2();
  const onClickDeeplinkAction = onClick;
  const isLink = React12.useMemo(
    () => isLinkAction(onClickDeeplinkAction),
    [onClickDeeplinkAction]
  );
  const handleOnClick = React12.useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({
          event
        }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  return /* @__PURE__ */ React12.createElement(
    SpendingAccountCard,
    {
      accountName,
      amount,
      ctaText,
      icon,
      title,
      trailingIcon,
      onClick: handleOnClick,
      href: onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url,
      isLink
    }
  );
}

// src/components/masonry-renderers/spending-account-widget/spending-account-widget-renderer.component.tsx
import * as React14 from "react";
import {
  useMasonryEngineActionEmitter
} from "@leagueplatform/masonry-engine";
import {
  Box as Box8,
  StackLayout as StackLayout2,
  UtilityText,
  Button,
  Divider,
  ParagraphText,
  Image as Image3
} from "@leagueplatform/genesis-core";
import {
  isLinkAction as isLinkAction2
} from "@leagueplatform/masonry-renderers";
import { useUniqueId as useUniqueId2 } from "@leagueplatform/web-common";
import { InternalOrExternalLink as Link2 } from "@leagueplatform/web-common-components";

// src/components/section-header-with-icon/section-header-with-icon.component.tsx
import * as React13 from "react";
import {
  Box as Box7,
  HeadingText as HeadingText3,
  Icon as IconComponent
} from "@leagueplatform/genesis-core";
function SectionHeaderWithIcon({
  heading,
  headingLevel = "2",
  icon,
  id
}) {
  const { icon: iconName, description = "" } = icon || {};
  return /* @__PURE__ */ React13.createElement(
    Box7,
    {
      css: {
        display: "flex",
        alignItems: "flex-start",
        gap: "$threeQuarters"
      }
    },
    iconName && /* @__PURE__ */ React13.createElement(Box7, null, /* @__PURE__ */ React13.createElement(
      IconComponent,
      {
        css: { width: 42 },
        icon: iconName,
        label: description
      }
    )),
    /* @__PURE__ */ React13.createElement(Box7, { css: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ React13.createElement(HeadingText3, { size: "lg", id, level: headingLevel }, heading))
  );
}

// src/constants/indicator-map.constants.ts
var buttonIndicatorMap = {
  newWindowInternal: "newWindowInternal",
  externalLink: "externalLink",
  none: void 0
};

// src/components/masonry-renderers/spending-account-widget/spending-account-widget-renderer.component.tsx
var NODE_TYPE_SPENDING_ACCOUNT_WIDGET = "spendingAccountWidget";
function SpendingAccountWidgetRenderer({
  sponsorLogo,
  headingLeadingIcon,
  heading,
  headingLevel = "2",
  description,
  subtext,
  ctaType,
  isCTALabelGeneric,
  hasEndDivider = false,
  spendingAccountCard,
  button,
  onClick
}) {
  var _a;
  const invokeAction = useMasonryEngineActionEmitter();
  const onClickDeeplinkAction = onClick;
  const uniqueId = useUniqueId2({
    prefix: "spending-account-widget"
  });
  const headingId = `${uniqueId}-heading`;
  const isLink = React14.useMemo(
    () => isLinkAction2(onClickDeeplinkAction),
    [onClickDeeplinkAction]
  );
  const href = onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url;
  const handleOnClick = React14.useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({
          event
        }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  return /* @__PURE__ */ React14.createElement(StackLayout2, { as: "section", "aria-labelledby": headingId, spacing: "$oneAndHalf" }, sponsorLogo && /* @__PURE__ */ React14.createElement(Box8, null, /* @__PURE__ */ React14.createElement(
    Image3,
    {
      src: sponsorLogo.url,
      alt: (_a = sponsorLogo.description) != null ? _a : "",
      width: sponsorLogo.width,
      height: sponsorLogo.height,
      loading: "lazy",
      css: { maxWidth: "100%" }
    }
  )), /* @__PURE__ */ React14.createElement(StackLayout2, { spacing: "$oneAndHalf" }, /* @__PURE__ */ React14.createElement(Box8, { css: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ React14.createElement(
    SectionHeaderWithIcon,
    {
      heading,
      headingLevel,
      icon: headingLeadingIcon,
      id: headingId
    }
  )), description && /* @__PURE__ */ React14.createElement(Box8, null, /* @__PURE__ */ React14.createElement(ParagraphText, null, description)), subtext && /* @__PURE__ */ React14.createElement(UtilityText, { size: "sm", color: "subdued" }, subtext), ctaType === "spendingAccountCard" && spendingAccountCard && /* @__PURE__ */ React14.createElement(
    SpendingAccountCard,
    {
      accountName: heading,
      amount: spendingAccountCard.amount,
      ctaText: spendingAccountCard.ctaLabel,
      href: onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url,
      icon: spendingAccountCard.icon,
      isLink,
      onClick: handleOnClick,
      title: spendingAccountCard.title,
      trailingIcon: spendingAccountCard.trailingIcon
    }
  ), ctaType === "button" && button && /* @__PURE__ */ React14.createElement(Box8, null, /* @__PURE__ */ React14.createElement(
    Button,
    __spreadValues({
      size: "medium",
      priority: "secondary",
      onClick: handleOnClick,
      indicator: button.indicator ? buttonIndicatorMap[button.indicator] : void 0,
      id: isCTALabelGeneric ? `${headingId}-cta` : void 0,
      "aria-labelledby": isCTALabelGeneric ? `${headingId}-cta ${headingId}` : void 0
    }, isLink && {
      as: Link2,
      href
    }),
    button.label
  ))), hasEndDivider && /* @__PURE__ */ React14.createElement(Divider, null));
}

// src/components/masonry-renderers/additional-benefits-widget/additional-benefits-widget-renderer.component.tsx
import * as React15 from "react";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter2
} from "@leagueplatform/masonry-engine";
import {
  Box as Box9,
  StackLayout as StackLayout3,
  UtilityText as UtilityText2,
  Button as Button2,
  Divider as Divider2,
  ParagraphText as ParagraphText2,
  TextAction as TextAction2,
  Image as Image4
} from "@leagueplatform/genesis-core";
import {
  isLinkAction as isLinkAction3
} from "@leagueplatform/masonry-renderers";
import { useUniqueId as useUniqueId3 } from "@leagueplatform/web-common";
import { InternalOrExternalLink as Link3 } from "@leagueplatform/web-common-components";
import { useIntl } from "@leagueplatform/locales";
var NODE_TYPE_ADDITIONAL_BENEFITS_WIDGET = "additionalBenefitsWidget";
function AdditionalBenefitsWidgetRenderer({
  sponsorLogo,
  headingLeadingIcon,
  heading,
  headingLevel = "2",
  description,
  subtext,
  isCTALabelGeneric,
  hasEndDivider = false,
  button,
  onClick,
  moreDetails,
  onMoreDetailsClick
}) {
  var _a;
  const { $tifelse } = useIntl();
  const invokeAction = useMasonryEngineActionEmitter2();
  const [moreDetailsVisible, setMoreDetailsVisible] = React15.useState(false);
  const onClickDeeplinkAction = onClick;
  const uniqueId = useUniqueId3({
    prefix: "additional-benefits-widget"
  });
  const headingId = `${uniqueId}-heading`;
  const isLink = React15.useMemo(
    () => isLinkAction3(onClickDeeplinkAction),
    [onClickDeeplinkAction]
  );
  const href = onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url;
  const handleOnClick = React15.useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({
          event
        }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  const handleMoreDetailsClick = React15.useCallback(
    (event) => {
      setMoreDetailsVisible((prev) => !prev);
      if (onMoreDetailsClick) {
        invokeAction(__spreadValues({
          event
        }, onMoreDetailsClick));
      }
    },
    [invokeAction, onMoreDetailsClick]
  );
  return /* @__PURE__ */ React15.createElement(StackLayout3, { as: "section", "aria-labelledby": headingId, spacing: "$oneAndHalf" }, sponsorLogo && /* @__PURE__ */ React15.createElement(Box9, null, /* @__PURE__ */ React15.createElement(
    Image4,
    {
      src: sponsorLogo.url,
      alt: (_a = sponsorLogo.description) != null ? _a : "",
      width: sponsorLogo.width,
      height: sponsorLogo.height,
      loading: "lazy",
      css: { maxWidth: "100%" }
    }
  )), /* @__PURE__ */ React15.createElement(StackLayout3, { spacing: "$oneAndHalf" }, /* @__PURE__ */ React15.createElement(Box9, { css: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ React15.createElement(
    SectionHeaderWithIcon,
    {
      heading,
      headingLevel,
      icon: headingLeadingIcon,
      id: headingId
    }
  )), description && /* @__PURE__ */ React15.createElement(StackLayout3, { spacing: "$oneAndHalf" }, /* @__PURE__ */ React15.createElement(Box9, null, /* @__PURE__ */ React15.createElement(ParagraphText2, null, description), moreDetails && /* @__PURE__ */ React15.createElement(ParagraphText2, { hidden: !moreDetailsVisible }, moreDetails)), moreDetails && /* @__PURE__ */ React15.createElement(
    TextAction2,
    {
      "aria-expanded": moreDetailsVisible,
      "aria-labelledby": `${headingId}-more-details ${headingId}`,
      as: "button",
      color: "subdued",
      id: `${headingId}-more-details`,
      onClick: handleMoreDetailsClick,
      icon: moreDetailsVisible ? "interfaceChevronUp" : "interfaceChevronDown"
    },
    $tifelse(
      moreDetailsVisible,
      "BENEFITS_MORE_DETAILS_EXPANDED_LABEL",
      "BENEFITS_MORE_DETAILS_COLLAPSED_LABEL"
    )
  )), subtext && /* @__PURE__ */ React15.createElement(UtilityText2, { size: "sm", color: "subdued" }, subtext), button && /* @__PURE__ */ React15.createElement(Box9, null, /* @__PURE__ */ React15.createElement(
    Button2,
    __spreadValues({
      size: "medium",
      priority: "secondary",
      onClick: handleOnClick,
      indicator: button.indicator ? buttonIndicatorMap[button.indicator] : void 0,
      id: isCTALabelGeneric ? `${headingId}-cta` : void 0,
      "aria-labelledby": isCTALabelGeneric ? `${headingId}-cta ${headingId}` : void 0
    }, isLink && {
      as: Link3,
      href
    }),
    button.label
  ))), hasEndDivider && /* @__PURE__ */ React15.createElement(Divider2, null));
}

// src/components/masonry-renderers/coverage-details-widget/coverage-details-widget-renderer.component.tsx
import * as React19 from "react";
import {
  Box as Box11,
  HeadingText as HeadingText5,
  ParagraphText as ParagraphText6,
  StackLayout as StackLayout5
} from "@leagueplatform/genesis-core";
import { useUniqueId as useUniqueId6 } from "@leagueplatform/web-common";
import { Accordion as AccordionComponent } from "@leagueplatform/genesis-core-alpha";
import {
  useInvokeAction as useInvokeAction4
} from "@leagueplatform/masonry-renderers";

// src/components/masonry-renderers/coverage-details-widget/components/coverage-details-widget-card.component.tsx
import * as React16 from "react";
import {
  Box as Box10,
  Image as Image5,
  ParagraphText as ParagraphText3,
  TextAction as TextAction3
} from "@leagueplatform/genesis-core";
import { SidebarLayout } from "@leagueplatform/genesis-core-alpha";
import {
  isLinkAction as isLinkAction4,
  useInvokeAction as useInvokeAction3
} from "@leagueplatform/masonry-renderers";
import { InternalOrExternalLink as Link4 } from "@leagueplatform/web-common-components";
var CardComponent = ({ card, headingId, onClick }) => {
  const invokeAction = useInvokeAction3();
  const { image, description, cta } = card;
  const ctaId = `${headingId}-cta`;
  const ctaLabelledbyId = headingId ? `${ctaId} ${headingId}` : void 0;
  const onClickDeeplinkAction = onClick;
  const href = onClickDeeplinkAction == null ? void 0 : onClickDeeplinkAction.payload.url;
  const isLink = React16.useMemo(
    () => isLinkAction4(onClickDeeplinkAction),
    [onClickDeeplinkAction]
  );
  const handleOnClick = React16.useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({
          event
        }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  return /* @__PURE__ */ React16.createElement(
    SidebarLayout,
    {
      css: { width: "100%", alignItems: "center" },
      spacing: "$oneAndHalf",
      sidebarSide: "leading",
      sidebarSize: "lg"
    },
    /* @__PURE__ */ React16.createElement(Box10, null, /* @__PURE__ */ React16.createElement(
      Image5,
      {
        src: image.url,
        alt: image.description,
        css: { maxWidth: "100%" }
      }
    )),
    /* @__PURE__ */ React16.createElement(Box10, { css: { display: "flex", flexDirection: "column", gap: "$one" } }, description && /* @__PURE__ */ React16.createElement(ParagraphText3, null, description), cta && /* @__PURE__ */ React16.createElement(
      TextAction3,
      __spreadValues({
        as: "button",
        indicator: "disclosure",
        size: "large",
        css: { width: "fit-content" },
        "aria-labelledby": ctaLabelledbyId,
        id: ctaId,
        onClick: handleOnClick
      }, isLink && {
        as: Link4,
        href
      }),
      cta.label
    ))
  );
};

// src/components/masonry-renderers/coverage-details-widget/components/coverage-details-widget-section.component.tsx
import * as React18 from "react";
import {
  HeadingText as HeadingText4,
  ParagraphText as ParagraphText5,
  StackLayout as StackLayout4
} from "@leagueplatform/genesis-core";
import { useUniqueId as useUniqueId5 } from "@leagueplatform/web-common";
import { Accordion } from "@leagueplatform/genesis-core-alpha";

// src/components/masonry-renderers/coverage-details-widget/components/coverage-details-widget-table.component.tsx
import * as React17 from "react";
import {
  ParagraphText as ParagraphText4
} from "@leagueplatform/genesis-core";
import { useUniqueId as useUniqueId4 } from "@leagueplatform/web-common";
import { Table } from "@leagueplatform/genesis-core-alpha";
var TableComponent = ({
  table
}) => {
  const {
    tableName,
    hasBorder = true,
    headerBackgroundColor = "secondary",
    headers,
    rows
  } = table;
  const uniqueId = useUniqueId4();
  if (!(headers == null ? void 0 : headers.length) || !(rows == null ? void 0 : rows.length))
    return null;
  return /* @__PURE__ */ React17.createElement(Table, { tableName, border: hasBorder, isResponsive: true }, /* @__PURE__ */ React17.createElement(Table.Head, null, /* @__PURE__ */ React17.createElement(Table.Row, null, headers.map((header) => /* @__PURE__ */ React17.createElement(
    Table.Header,
    {
      key: header.id,
      label: header.name,
      backgroundColor: headerBackgroundColor
    }
  )))), /* @__PURE__ */ React17.createElement(Table.Body, null, rows.map((row, rowIndex) => /* @__PURE__ */ React17.createElement(
    Table.Row,
    {
      key: `${uniqueId}-${rowIndex}`
    },
    row.row.map((cell, cellIndex) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ React17.createElement(Table.Cell, { key: `${uniqueId}-${rowIndex}-${cellIndex}` }, /* @__PURE__ */ React17.createElement(ParagraphText4, null, cell))
    ))
  ))));
};

// src/components/masonry-renderers/coverage-details-widget/components/coverage-details-widget-section.component.tsx
var SectionComponent = ({ section, sectionIndex, onClick: onClickCallback }) => {
  var _a, _b;
  const {
    heading,
    headingLevel = "3",
    headingSize = "md",
    accordion,
    description,
    table
  } = section;
  const sectionId = useUniqueId5({ prefix: "coverage-details-section-" });
  const accordionId = (_a = accordion == null ? void 0 : accordion.id) != null ? _a : `${sectionId}-accordion`;
  const isExpanded = (_b = accordion == null ? void 0 : accordion.isExpanded) != null ? _b : false;
  const handleAccordionClick = React18.useCallback(() => {
    if (onClickCallback) {
      onClickCallback(sectionIndex, !isExpanded);
    }
  }, [sectionIndex, isExpanded, onClickCallback]);
  const sectionContent = /* @__PURE__ */ React18.createElement(StackLayout4, { css: { width: "100%" }, spacing: "$one" }, description && /* @__PURE__ */ React18.createElement(ParagraphText5, null, description), table && /* @__PURE__ */ React18.createElement(TableComponent, { table }));
  if (accordion && heading) {
    return /* @__PURE__ */ React18.createElement(
      Accordion,
      {
        heading,
        headingLevel,
        headingSize,
        defaultExpanded: accordion.isExpanded,
        isExpanded,
        id: accordionId,
        onClick: handleAccordionClick,
        css: {
          width: "100%",
          marginBlockStart: "$none",
          borderBlockStartColor: "$onSurfaceBorderSubdued"
        },
        dividerPosition: accordion.dividerPosition
      },
      sectionContent
    );
  }
  return /* @__PURE__ */ React18.createElement(StackLayout4, { css: { width: "100%" }, spacing: "$one" }, heading && /* @__PURE__ */ React18.createElement(HeadingText4, { level: headingLevel, size: headingSize }, heading), sectionContent);
};

// src/components/masonry-renderers/coverage-details-widget/coverage-details-widget-renderer.component.tsx
var NODE_TYPE_COVERAGE_DETAILS_WIDGET = "coverageDetailsWidget";
function CoverageDetailsWidgetRenderer({
  heading,
  headingLevel = "2",
  headingSize = "lg",
  card,
  description,
  sections = [],
  onCardClick,
  onAccordionClick,
  nodeId,
  accordion
}) {
  var _a, _b, _c, _d;
  const sectionId = useUniqueId6({ prefix: "coverage-details-section-" });
  const headingId = (_a = accordion == null ? void 0 : accordion.id) != null ? _a : `${sectionId}-heading`;
  const invokeAction = useInvokeAction4();
  const handleAccordionClick = React19.useCallback(
    (accordionId) => {
      const accordionState = !(accordion == null ? void 0 : accordion.isExpanded);
      invokeAction({
        type: "setNodeState",
        namespace: "default",
        payload: {
          nodeId,
          state: {
            accordion: __spreadProps(__spreadValues({}, accordion), {
              isExpanded: accordionState
            })
          }
        }
      });
      if (onAccordionClick) {
        invokeAction(__spreadProps(__spreadValues({}, onAccordionClick), {
          payload: {
            accordionId,
            isExpanded: accordionState
          }
        }));
      }
    },
    [accordion, invokeAction, nodeId, onAccordionClick]
  );
  const handleSubAccordionClick = React19.useCallback(
    (sectionIndex, newAccordionState) => {
      var _a2, _b2;
      const accordionId = (_b2 = (_a2 = sections[sectionIndex]) == null ? void 0 : _a2.accordion) == null ? void 0 : _b2.id;
      const updatedSections = sections.map((section, index) => {
        if (index === sectionIndex) {
          return __spreadProps(__spreadValues({}, section), {
            accordion: __spreadProps(__spreadValues({}, section.accordion), {
              isExpanded: newAccordionState
            })
          });
        }
        return section;
      });
      invokeAction({
        type: "setNodeState",
        namespace: "default",
        payload: {
          nodeId,
          state: {
            sections: updatedSections
          }
        }
      });
      if (onAccordionClick && accordionId) {
        invokeAction(__spreadProps(__spreadValues({}, onAccordionClick), {
          payload: {
            accordionId,
            isExpanded: newAccordionState
          }
        }));
      }
    },
    [sections, invokeAction, nodeId, onAccordionClick]
  );
  if (!sections.length && !heading && !card) {
    return null;
  }
  const hasSubsectionAccordion = sections.some((section) => section.accordion);
  const hasHeaderSection = !!heading || !!description || !!card;
  const isHeaderSectionAccordion = accordion && heading;
  const mainContent = /* @__PURE__ */ React19.createElement(
    StackLayout5,
    {
      css: { width: "100%" },
      spacing: hasSubsectionAccordion ? "$none" : "$two"
    },
    sections.map((section, index) => {
      var _a2;
      const key = (_a2 = section.heading) != null ? _a2 : `section-${index}`;
      return /* @__PURE__ */ React19.createElement(
        SectionComponent,
        {
          key: `section-${key}`,
          section,
          sectionIndex: index,
          onClick: handleSubAccordionClick
        }
      );
    })
  );
  if (isHeaderSectionAccordion) {
    return /* @__PURE__ */ React19.createElement(Box11, { as: "section", css: { width: "100%" } }, /* @__PURE__ */ React19.createElement(
      AccordionComponent,
      {
        heading,
        headingLevel,
        headingSize,
        defaultExpanded: (_b = accordion == null ? void 0 : accordion.isExpanded) != null ? _b : false,
        isExpanded: accordion == null ? void 0 : accordion.isExpanded,
        css: {
          width: "100%",
          marginBlockStart: "$none",
          borderBlockColor: "$onSurfaceBorderSubdued"
        },
        id: headingId,
        onClick: () => handleAccordionClick(headingId),
        dividerPosition: accordion == null ? void 0 : accordion.dividerPosition
      },
      /* @__PURE__ */ React19.createElement(StackLayout5, { css: { width: "100%" }, spacing: "$oneAndHalf" }, description && /* @__PURE__ */ React19.createElement(ParagraphText6, null, description), card && /* @__PURE__ */ React19.createElement(
        CardComponent,
        {
          card,
          headingId: ((_c = card.cta) == null ? void 0 : _c.isCtaGeneric) ? headingId : void 0,
          onClick: onCardClick
        }
      ), mainContent)
    ));
  }
  return /* @__PURE__ */ React19.createElement(StackLayout5, { as: "section", spacing: "$twoAndHalf" }, hasHeaderSection && /* @__PURE__ */ React19.createElement(StackLayout5, { spacing: "$oneAndHalf", css: { width: "100%" } }, heading && /* @__PURE__ */ React19.createElement(HeadingText5, { level: headingLevel, size: headingSize, id: headingId }, heading), description && /* @__PURE__ */ React19.createElement(ParagraphText6, null, description), card && /* @__PURE__ */ React19.createElement(
    CardComponent,
    {
      card,
      headingId: ((_d = card.cta) == null ? void 0 : _d.isCtaGeneric) ? headingId : void 0,
      onClick: onCardClick
    }
  )), mainContent);
}

// src/components/masonry-renderers/id-card-widget/id-card-widget-renderer.component.tsx
import * as React22 from "react";
import {
  useMasonryEngineActionEmitter as useMasonryEngineActionEmitter3
} from "@leagueplatform/masonry-engine";
import {
  StackLayout as StackLayout6,
  HeadingText as HeadingText6,
  Box as Box13,
  UtilityText as UtilityText4
} from "@leagueplatform/genesis-core";
import { SidebarLayout as SidebarLayout2 } from "@leagueplatform/genesis-core-alpha";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { useUniqueId as useUniqueId7 } from "@leagueplatform/web-common";

// src/components/masonry-helpers/masonry-text-action.component.tsx
import * as React20 from "react";
import { TextAction as TextAction4 } from "@leagueplatform/genesis-core";

// src/components/masonry-helpers/masonry-action-utils.ts
import { InternalOrExternalLink } from "@leagueplatform/web-common-components";
var getMasonryActionComponentSemantics = ({
  action
}) => {
  var _a, _b;
  if (!action) {
    return {};
  }
  const isLink = action.type === "deeplink" && Boolean((_a = action.payload) == null ? void 0 : _a.url);
  let url;
  let as = "button";
  if (isLink) {
    url = (_b = action.payload) == null ? void 0 : _b.url;
    as = InternalOrExternalLink;
  }
  return { href: url, as };
};

// src/components/masonry-helpers/masonry-text-action.component.tsx
var MasonryTextAction = (props) => {
  const { action } = props;
  const masonryActionComponentSemantics = getMasonryActionComponentSemantics({
    action
  });
  return /* @__PURE__ */ React20.createElement(TextAction4, __spreadValues(__spreadValues({}, masonryActionComponentSemantics), props));
};

// src/utils/get-sub-heading-level.util.ts
var getSubHeadingLevel = (headingLevel) => {
  if (!headingLevel) {
    return "3";
  }
  if (headingLevel === "display") {
    return headingLevel;
  }
  const currentLevel = parseInt(headingLevel, 10);
  const nextLevel = Math.min(currentLevel + 1, 6);
  return nextLevel.toString();
};

// src/components/masonry-renderers/id-card-widget/components/policy-information.component.tsx
import * as React21 from "react";
import { Box as Box12, ParagraphText as ParagraphText7, UtilityText as UtilityText3 } from "@leagueplatform/genesis-core";
var PolicyInformationItem = ({ label, value }) => /* @__PURE__ */ React21.createElement(Box12, { as: "li" }, /* @__PURE__ */ React21.createElement(
  UtilityText3,
  {
    css: {
      typography: "$overline",
      textTransform: "uppercase"
    }
  },
  label,
  /* @__PURE__ */ React21.createElement(
    ParagraphText7,
    {
      css: { display: "block", marginBlockStart: "$half" },
      as: "span"
    },
    value
  )
));

// src/components/masonry-renderers/id-card-widget/id-card-widget-renderer.component.tsx
var NODE_TYPE_ID_CARD_WIDGET = "idCardWidget";
var MAX_CARD_WIDTH = "384px";
function IdCardWidgetRenderer({
  heading,
  headingLevel = "2",
  frontCard: frontImage,
  backCard: backImage,
  policyInformation,
  cardActions,
  onDownloadClick,
  onOrderNewCardClick,
  onPrintClick,
  onReportCardLostStolenClick
}) {
  const { formatMessage } = useIntl2();
  const cardActionsId = useUniqueId7({ prefix: "card-actions" });
  const headingId = useUniqueId7({ prefix: "id-card" });
  const hasImages = (frontImage == null ? void 0 : frontImage.url) || (backImage == null ? void 0 : backImage.url);
  const hasPolicyInformation = (policyInformation == null ? void 0 : policyInformation.length) > 0;
  const hasCardActions = React22.useMemo(
    () => cardActions.length > 0 && [
      onDownloadClick,
      onOrderNewCardClick,
      onPrintClick,
      onReportCardLostStolenClick
    ].some((action) => action !== void 0),
    [
      cardActions,
      onDownloadClick,
      onOrderNewCardClick,
      onPrintClick,
      onReportCardLostStolenClick
    ]
  );
  const invokeAction = useMasonryEngineActionEmitter3();
  const subHeadingLevel = getSubHeadingLevel(headingLevel);
  const actionMap = React22.useMemo(
    () => ({
      print: onPrintClick,
      download: onDownloadClick,
      orderNewCard: onOrderNewCardClick,
      reportCardLostStolen: onReportCardLostStolenClick
    }),
    [
      onPrintClick,
      onDownloadClick,
      onOrderNewCardClick,
      onReportCardLostStolenClick
    ]
  );
  const handleCardActionClick = React22.useCallback(
    (event, actionType) => {
      const action = actionMap[actionType];
      if (action) {
        invokeAction(__spreadValues({ event }, action));
      }
    },
    [invokeAction, actionMap]
  );
  return /* @__PURE__ */ React22.createElement(StackLayout6, { spacing: "$oneAndHalf", as: "section", "aria-labelledby": headingId }, /* @__PURE__ */ React22.createElement(HeadingText6, { id: headingId, level: headingLevel, size: "lg" }, heading), /* @__PURE__ */ React22.createElement(SidebarLayout2, null, hasImages && /* @__PURE__ */ React22.createElement(StackLayout6, { spacing: "$oneAndHalf", css: { maxWidth: MAX_CARD_WIDTH } }, frontImage && /* @__PURE__ */ React22.createElement(
    IdCard,
    {
      source: frontImage.url,
      description: frontImage.description,
      aspectRatio: frontImage.aspectRatio,
      type: frontImage.type
    }
  ), backImage && /* @__PURE__ */ React22.createElement(
    IdCard,
    {
      source: backImage.url,
      description: backImage.description,
      aspectRatio: backImage.aspectRatio,
      type: backImage.type
    }
  )), /* @__PURE__ */ React22.createElement(StackLayout6, { spacing: "$oneAndHalf" }, hasPolicyInformation && /* @__PURE__ */ React22.createElement(StackLayout6, { as: "ul", spacing: "$oneAndHalf" }, policyInformation.map(({ label, value }) => /* @__PURE__ */ React22.createElement(
    PolicyInformationItem,
    {
      key: label,
      label,
      value
    }
  ))), hasCardActions && /* @__PURE__ */ React22.createElement(
    StackLayout6,
    {
      spacing: "$one",
      as: "section",
      "aria-labelledby": cardActionsId
    },
    /* @__PURE__ */ React22.createElement(
      UtilityText4,
      {
        as: HeadingText6,
        css: {
          typography: "$overline",
          textTransform: "uppercase"
        },
        id: cardActionsId,
        level: subHeadingLevel
      },
      formatMessage({
        id: "BENEFITS_CARD_ACTIONS_HEADING"
      })
    ),
    /* @__PURE__ */ React22.createElement(StackLayout6, { as: "ul", spacing: "$one" }, cardActions.map(({ leadingIcon, label, type }) => {
      const action = actionMap[type];
      if (!action) {
        return null;
      }
      return /* @__PURE__ */ React22.createElement(Box13, { as: "li", key: label }, /* @__PURE__ */ React22.createElement(
        MasonryTextAction,
        {
          key: label,
          icon: leadingIcon == null ? void 0 : leadingIcon.icon,
          onClick: (event) => handleCardActionClick(event, type),
          action
        },
        label
      ));
    }))
  ))));
}

// src/init-masonry-registry.ts
var registerBenefitsRenderer = (nodeType, renderer) => {
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_NAMESPACE_BENEFITS,
    nodeType,
    renderer
  );
};
var initMasonryRegistry = () => {
  registerBenefitsRenderer(NODE_TYPE_BORDER_BOX, BorderBoxRenderer);
  registerBenefitsRenderer(
    NODE_TYPE_MEMBER_DROPDOWN_CONTAINER,
    MemberDropdownContainer
  );
  registerBenefitsRenderer(NODE_TYPE_MEMBER_DROPDOWN, MemberDropdownRenderer);
  registerBenefitsRenderer(
    NODE_TYPE_BENEFITS_SECTION_HEADER,
    BenefitsSectionHeaderRenderer
  );
  registerBenefitsRenderer(NODE_TYPE_ID_CARD, IdCardRenderer);
  registerBenefitsRenderer(
    NODE_TYPE_ACCORDION_ITEM,
    MasonryAccordionItemRenderer
  );
  registerBenefitsRenderer(
    NODE_TYPE_SPENDING_ACCOUNT_CARD,
    SpendingAccountCardRenderer
  );
  registerBenefitsRenderer(
    NODE_TYPE_SPENDING_ACCOUNT_WIDGET,
    SpendingAccountWidgetRenderer
  );
  registerBenefitsRenderer(
    NODE_TYPE_ADDITIONAL_BENEFITS_WIDGET,
    AdditionalBenefitsWidgetRenderer
  );
  registerBenefitsRenderer(
    NODE_TYPE_COVERAGE_DETAILS_WIDGET,
    CoverageDetailsWidgetRenderer
  );
  registerBenefitsRenderer(NODE_TYPE_ID_CARD_WIDGET, IdCardWidgetRenderer);
  registerBenefitsRenderer(NODE_TYPE_SIDEBAR_LAYOUT, SidebarLayoutRenderer);
  registerBenefitsRenderer(NODE_TYPE_GRID_LAYOUT, GridLayoutRenderer);
  registerBenefitsRenderer(NODE_TYPE_SECTION_HEADER, SectionHeaderRenderer);
  registerBenefitsRenderer(
    NODE_TYPE_PLAN_SPENDING_CONTAINER,
    PlanSpendingContainerRenderer
  );
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
var BENEFITS_MODULE_ASSETS_MAP = {};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(BENEFITS_MODULE_ASSETS_MAP);
};

// src/benefits.routes.tsx
import * as React25 from "react";
import { Route, Routes } from "@leagueplatform/routing";

// src/constants/benefits-urls.consants.ts
var BENEFITS_URLS = {
  benefitsLandingPage: "",
  benefitsCategoryPage: "/:pageType",
  benefitsDetailPage: "/:pageType/:benefitId"
};

// src/pages/benefits-landing.page.tsx
import * as React23 from "react";
import { getMasonryDriver } from "@leagueplatform/masonry";
import { MasonryEngine } from "@leagueplatform/masonry-engine";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { PageContainer } from "@leagueplatform/web-common-components";

// src/benefits.config.ts
import {
  useConfigProperty
} from "@leagueplatform/config";
var defaultConfig = {
  benefitsLandingMasonryConfigKey: BENEFITS_ROOT_NODE_IDS.benefitsLandingRootNodeId,
  benefitsDetailsMasonryConfigKey: BENEFITS_ROOT_NODE_IDS.benefitsDetailRootNodeId
};
var useBenefitsConfig = () => useConfigProperty("benefits", defaultConfig);

// src/pages/benefits-landing.page.tsx
function BenefitsLandingPage() {
  const { formatMessage } = useIntl3();
  const config = useBenefitsConfig();
  const MasonryBenefitsLandingDriver = getMasonryDriver({
    rootNodeId: config.benefitsLandingMasonryConfigKey
  });
  useDocumentTitle(
    formatMessage({ id: "BENEFITS_BENEFITS_LANDING_PAGE_TITLE" })
  );
  return /* @__PURE__ */ React23.createElement(PageContainer, null, /* @__PURE__ */ React23.createElement(MasonryEngine, { driver: MasonryBenefitsLandingDriver }));
}

// src/pages/benefits-detail.page.tsx
import * as React24 from "react";
import { useParamsLegacy as useParams } from "@leagueplatform/routing";
import { getMasonryDriver as getMasonryDriver2 } from "@leagueplatform/masonry";
import { MasonryEngine as MasonryEngine2 } from "@leagueplatform/masonry-engine";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { useDocumentTitle as useDocumentTitle2 } from "@leagueplatform/web-common";
import { PageContainer as PageContainer2 } from "@leagueplatform/web-common-components";
function BenefitsDetailPage() {
  const { formatMessage } = useIntl4();
  const { benefitId = "", pageType = "" } = useParams();
  const config = useBenefitsConfig();
  const MasonryBenefitsDetailDriver = getMasonryDriver2({
    rootNodeId: config.benefitsDetailsMasonryConfigKey,
    queryParams: { benefitId, pageType }
  });
  useDocumentTitle2(
    formatMessage({ id: "BENEFITS_BENEFITS_DETAIL_PAGE_TITLE" })
  );
  return /* @__PURE__ */ React24.createElement(PageContainer2, null, /* @__PURE__ */ React24.createElement(MasonryEngine2, { driver: MasonryBenefitsDetailDriver }));
}

// src/benefits.routes.tsx
var BenefitsRoutes = () => /* @__PURE__ */ React25.createElement(Routes, null, /* @__PURE__ */ React25.createElement(
  Route,
  {
    path: `${BENEFITS_URLS.benefitsLandingPage}`,
    element: /* @__PURE__ */ React25.createElement(BenefitsLandingPage, null)
  }
), /* @__PURE__ */ React25.createElement(
  Route,
  {
    path: `${BENEFITS_URLS.benefitsCategoryPage}`,
    element: /* @__PURE__ */ React25.createElement(BenefitsDetailPage, null)
  }
), /* @__PURE__ */ React25.createElement(
  Route,
  {
    path: `${BENEFITS_URLS.benefitsDetailPage}`,
    element: /* @__PURE__ */ React25.createElement(BenefitsDetailPage, null)
  }
));

// src/index.ts
initModule();
initMasonryRegistry();
export {
  BenefitsRoutes
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/benefits'] = window.leagueSDKsPresent['@leagueplatform/benefits'] || [];
    window.leagueSDKsPresent['@leagueplatform/benefits'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/benefits'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/benefits module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map